import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectUserAppSettings } from "../../modules/hub/features/UserAppSettings/selectors/userAppSettingsSelectors";
import { SidebarProvider } from "@/components/ui/sidebar";
import WideSidebar from "../WideSidebar/WideSidebar";
import TopNavBar from "../TopNavBar/TopNavBar";
import MainContent from "../MainContent/MainContent";
import AppLegacyBanner from "@/components/AppLegacyBanner/AppLegacyBanner";
import SearchModal from "@/modules/hub/features/Search/components/SearchModal/SearchModal";
import { openSearchModal } from "@/modules/hub/features/Search/slices/searchSlice";

interface MainLayoutProps {
  section: string | null;
}

const MainLayout: React.FC<MainLayoutProps> = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [sidebarOpenWide, setSidebarOpenWide] = useState(true);
  const [hasManuallyToggled, setHasManuallyToggled] = useState(false);
  const userAppSettings = useSelector(selectUserAppSettings);
  const isAccountSetupIncomplete = userAppSettings && !userAppSettings.roleName;

  // Auto-collapse sidebar on /hub page for landing page experience
  useEffect(() => {
    // Only auto-collapse if user hasn't manually toggled the sidebar
    if (!hasManuallyToggled) {
      if (location.pathname === "/hub") {
        setSidebarOpenWide(false);
      } else {
        setSidebarOpenWide(true);
      }
    }
  }, [location.pathname, hasManuallyToggled]);

  // Global keyboard shortcut for search (Cmd/Ctrl + K)
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        dispatch(openSearchModal());
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [dispatch]);

  const handleSidebarToggle = () => {
    setSidebarOpenWide((prev) => !prev);
    setHasManuallyToggled(true);
  };

  return (
    <>
      <SidebarProvider onOpenChange={setSidebarOpenWide} open={sidebarOpenWide}>
        <WideSidebar />
        <div className="flex flex-1 flex-col min-w-0">
          <TopNavBar
            onSidebarToggle={handleSidebarToggle}
          />
          <MainContent>
            {isAccountSetupIncomplete ? (
              <div> IncompleteAccountSetup goes here</div>
            ) : (
              <Outlet />
            )}
          </MainContent>
        </div>
      </SidebarProvider>
      {/* Global Search Modal */}
      <SearchModal />
    </>
  );
};

export default MainLayout;
